<template>
  <div class="container_item">
    <div>
      <div class="block span3">
        <div class="product">
          <b-img-lazy class="store-item-header" :src="item.images[0].src"></b-img-lazy>
          <div class="buttons">
            <a v-b-modal="item.id" class="preview btn btn-large font-color-white">
              <i class="icon-eye-open"></i> See more
            </a>
            <b-modal
              :id="item.id"
              size="xl"
              centered
              ok-disabled
              ok-title="Add to cart"
              :title="item.name"
            >
              <SingleStoreItem v-bind:item="item" />
            </b-modal>
          </div>
        </div>
        <div class="info">
          <h4>{{item.name}}</h4>
          <span class="description">{{item.description}}</span>
          <div class="bottom_div">
            <span v-if="item.hidePrice" class="price-not-available">Price Available on call</span>
            <span v-if="!item.hidePrice" class="price">LE {{item.price.value}}/{{item.price.type}}</span>
            <b-button
              @click="migrateItemInfo(item.name, item.id)"
              id="buyNow"
              :disabled="outOfstock === 1"
              class="btn pull-right buyNowBut"
            >
              <router-link
                style="color: white;"
                :to="{ name: 'ContactUs', params: {type: 1, id: item.id , name: item.name} }"
              >{{state}}</router-link>
            </b-button>
          </div>
        </div>

        <div class="details">
          <span class="time">
            <div class="available_in_stock" v-if="item.quantity !== '0'">Available</div>
            <div class="out_of_stock" v-else>Out of stock</div>
          </span>
          <span class="rating pull-right">
            <span class="star"></span>
            <span class="star"></span>
            <span class="star"></span>
            <span class="star"></span>
            <span class="star"></span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SingleStoreItem from "./SingleStoreItem.vue";
import { setTimeout } from "timers";

export default {
  name: "StoreItems",
  // To use props, they must be declared
  props: {
    item: Object
  },
  components: {
    SingleStoreItem
  },

  data() {
    return {
      outOfstock: 0,
      state: "Reserve"
    };
  },
  mounted() {
    if (this.item.quantity === "0") {
      this.outOfstock = 1;
      this.state = "Soon";
    } else {
      this.outOfstock = 0;
      this.state = "Reserve";
    }
  },
  methods: {
    migrateItemInfo(name, id) {
      this.setActive(7);
      setTimeout(() => {
        // window.scrollTo(0,document.body.scrollHeight);
        document.getElementById("contact-form").scrollIntoView(false);
      }, 1000);
    },
    setActive(id) {
      document.documentElement.style.scrollBehavior = "auto";
      setTimeout(
        () => (document.documentElement.style.scrollBehavior = "smooth"),
        1000
      );
      document.getElementById("nav" + id).style.borderTop = "5px solid #00264A";
      var i;
      for (i = 2; i < 8; i++) {
        if ("nav" + i === "nav" + id) {
          continue;
        } else {
          document.getElementById("nav" + i).style.borderTop =
            "5px solid #dddddd";
        }
      }
    }
  }
};
</script>

<style scoped>
.container_item {
  min-width: 300px;
  max-width: 300px;
  padding: 25px 25px 25px 25px;
  display: inline-block;
}
.block {
  /*
    //display: block;
	//position: relative;
	//width: 295px;
	//border-radius: 5px;
    */
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}
.font-color-white {
  color: white !important;
}
.available_in_stock {
  float: left;
  color: green;
}

.buyNowBut {
  background-color: #307ae6;
  width: 80px;
}
.btn-secondary:hover {
  color: #fff;
  background-color: #023a8f;
}

.icon-eye-open {
}
.out_of_stock {
  float: left;
  color: red;
}
.product {
  display: block;
  position: relative;
}

.product img {
  width: 100%;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.info {
  display: block;
  position: relative;
  padding: 20px;
}

.details {
  border-top: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
  padding: 25px 20px;
}

.buttons {
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  background: rgba(255, 255, 255, 0);
  opacity: 0.85;
  -webkit-transition: opacity 0.25s ease-in;
  -ms-transition: opacity 0.25s ease-in;
  -moz-transition: opacity 0.25s ease-in;
  -o-transition: opacity 0.25s ease-in;
  transition: opacity 0.25s ease-in;
}

.product:hover .buttons,
.product:hover a {
  opacity: 1;
}
.product:hover .store-item-header {
  opacity: 0.2 !important;
}
.buttons:hover {
  opacity: 0.85;
}
.buttons a {
  display: block;
  position: absolute;
  left: 50px;
  width: 155px;
  border-radius: 2px;
  /*
    //padding: 15px 10px 15px 65px;
	//font-family: Helvetica, sans-serif;
    */

  text-transform: uppercase;
  color: #fff;
  text-decoration: none;
  opacity: 0;
}

a.buy {
  top: 20%;
}

a.preview {
  bottom: 40%;
  text-transform: none !important;
  font-weight: bold;
  background-color: #307ae6;
  -webkit-transition: opacity 0.25s ease-in;
  -ms-transition: opacity 0.25s ease-in;
  -moz-transition: opacity 0.25s ease-in;
  -o-transition: opacity 0.25s ease-in;
  transition: opacity 0.25s ease-in;
}
a.preview:hover {
  bottom: 40%;
  background-color: #0455ce;
}
.span3:hover {
  opacity: 1;
}
.info::after {
  display: block;
  position: absolute;
  top: -8px;
  left: 23px;
  content: "";
  width: 15px;
  height: 15px;
  background: #fff;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
}

.info h4 {
  position: relative;
  padding: 0 0 20px 0;
  margin: 0 0 20px 0;
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  font-size: 19px;
  line-height: 25px;
  color: #372f2b;
  letter-spacing: -1px;
}

.info h4::after {
  display: block;
  position: absolute;
  bottom: 0px;
  content: "";
  width: 100%;
  height: 2px;
  background: #1561d3;
}

.info .description {
  display: block;
  padding-bottom: 20px;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #5f5f5f;
  min-height: 100px;
  text-align: center;
  max-height: 100px;
}
.bottom_div {
  padding-top: 20px;
  height: 50px;
  width: 100%;
}

.info .price {
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #372f2b;
  line-height: 26px;
  display: inline;
}

.info .price-not-available {
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: rgb(126, 124, 124);
  line-height: 16px;
  display: inline;
  margin-left: -15px;
  position: relative;
  top: 5px;
}

.time {
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #372f2b;
  /*background: url("../img/clock-icon.png") no-repeat;*/
  background-position: 0 2px;
}

.modal-dialog {
  max-width: 800px !important;
  max-height: 600px !important;
  margin: 1.75rem auto;
}

.rating {
  unicode-bidi: bidi-override;
  direction: rtl;
  font-size: 15px;
}

.rating span.star {
  font-family: FontAwesome;
  font-weight: 400;
  font-style: normal;
  display: inline-block;
}

.rating span.star:hover {
  cursor: pointer;
}

.rating span.star:before {
  content: "\f006";
  padding-right: 5px;
  color: #999;
}

.rating span.star:hover:before,
.rating span.star:hover ~ span.star:before {
  content: "\f005";
  color: #e3cf7a;
}

@media (hover: none) and (pointer: coarse) {
  a.preview {
    opacity: 0.8;
    position: absolute;
    bottom: 0px;
  }
  a.preview:hover {
    bottom: 0%;
    background-color: #0455ce;
  }
}
@media screen and (max-width: 500px) {
  a.preview {
    opacity: 0.8;
    position: absolute;
    bottom: 0px;
  }
  a.preview:hover {
    bottom: 0%;
    background-color: #0455ce;
  }
}
</style>
